import { createFileRoute } from '@tanstack/react-router'
import { VehicleContentPage } from 'pages/vehicle-content/VehicleContent'

export const Route = createFileRoute('/vehicle-content')({
  component: VehicleContentPage,
})
